import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { BehaviorSubject, filter, take } from 'rxjs';
import { DEFAULT_POSITION_FALLBACK, MAPS_CONFIG } from '../consts/maps-config.const';
import { MapsConfig } from '../contract/map-config.contract';


type MapParams = MapsConfig & {
  libraries: string;
}


// TODO: Optimize a lib loading: https://www.npmjs.com/package/@googlemaps/js-api-loader
// TODO: After changes re-check if HttpClientJsonpModule is still necessary
@Injectable({
  providedIn: 'root',
})
export class MapLoaderService {
  private _isLoaded = new BehaviorSubject<boolean>(false);
  private requiredParams = {
    libraries: 'places,marker'
  };
  public readonly isLoaded = this._isLoaded.asObservable()
    .pipe(filter(Boolean), take(1));

  public readonly currentLocation = { lat: DEFAULT_POSITION_FALLBACK.lat, lng: DEFAULT_POSITION_FALLBACK.lon };

  constructor(
    @Optional() @Inject(MAPS_CONFIG) private configs: MapsConfig = {},
    private httpClient: HttpClient,
  ) { }

  initialize(): void {
    this.load(this.configs);
    this.getCurrentPosition();
  }

  private getCurrentPosition(): void {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        ({ coords: { latitude, longitude } }) => {
          this.currentLocation.lat = latitude;
          this.currentLocation.lng = longitude;
        },
        null,
        { enableHighAccuracy: false }
      );
    }
  }

  private load(configs: MapsConfig): void {
    const path = this.getPath();
    const params = this.getParams(configs);

    this._isLoaded.next(false);
    this.httpClient.jsonp(
      `${[path, params].filter(Boolean).join('?')}`,
      'callback'
    ).subscribe(() => {
      this._isLoaded.next(true);
    });
  }

  private getPath(): string {
    return 'https://maps.googleapis.com/maps/api/js';
  }

  private getParams(configs: MapsConfig): string {
    const params: MapParams = {
      ...(configs || {}),
      ...this.requiredParams
    }

    return Object.entries(params).map(([key, value]) => `${key}=${value}`).join('&');
  }
}
